import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  initialValue?: string;
  size?: 'sm' | 'lg';
  placeholder?: string;
  onSearch?: (keyword: string) => void;
}

export default function SearchBar({
  initialValue = '',
  size = 'sm',
  placeholder = '搜索电视剧、花絮资讯…',
  onSearch,
}: SearchBarProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();
  const isLarge = size === 'lg';

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (onSearch) {
      onSearch(keyword);
      return;
    }
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : '/search');
  };

  return (
    <form onSubmit={handleSubmit} role="search" className="w-full">
      <div
        className={`flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-50 pl-4 pr-1.5 transition-colors focus-within:border-primary-400 ${
          isLarge ? 'h-12' : 'h-10'
        }`}
      >
        <i className={`ri-search-line text-foreground-400 ${isLarge ? 'text-lg' : 'text-base'}`} />
        <input
          type="search"
          name="q"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={placeholder}
          aria-label="站内搜索"
          className={`min-w-0 flex-1 bg-transparent text-foreground-900 outline-none placeholder:text-foreground-400 ${
            isLarge ? 'text-base' : 'text-sm'
          }`}
        />
        <button
          type="submit"
          className={`shrink-0 whitespace-nowrap rounded-full bg-primary-500 font-label text-background-50 transition-colors hover:bg-primary-600 ${
            isLarge ? 'h-9 px-5 text-sm' : 'h-7 px-4 text-sm'
          }`}
        >
          搜索
        </button>
      </div>
    </form>
  );
}